import { SPARK_RESOURCE_TYPES } from 'constants/common';

export const getChatMessagesQueryKey = (
  chatID: string | undefined,
  pageSize: number
) => [SPARK_RESOURCE_TYPES.CHAT_MESSAGES, chatID, 'paginated', pageSize];
